module.exports = "pegasus_template/assets/themelp1/small/2.png";